import { useEffect, useState } from "react";
import { getDataClient } from "@/lib/dataClient";

export interface LiveKitTokenState {
  token: string | null;
  url: string;
  loading: boolean;
  error: string | null;
}

/**
 * Canlı ders için LiveKit erişim belirtecini (token) ve bağlantı adresini sağlar.
 * Token, sunucu tarafında (edge function) üretilir ve yalnızca oturum açmış,
 * o derse yetkili kullanıcılara verilir.
 */
export function useLiveKitToken(roomCode: string, userName: string): LiveKitTokenState {
  const [token, setToken] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const [url, setUrl] = useState((import.meta.env.VITE_PUBLIC_LIVEKIT_URL as string) || "");

  useEffect(() => {
    if (!roomCode) {
      setLoading(false);
      setError("Oda kodu bulunamadı.");
      return;
    }

    let cancelled = false;

    async function fetchToken() {
      setLoading(true);
      setError(null);
      try {
        const dataClient = getDataClient();
        const { data, error: fnError } = await dataClient.functions.invoke("livekit-token", {
          body: { roomCode, userName },
        });
        if (cancelled) return;
        if (fnError) {
          setError(fnError.message || "Bağlantı hatası.");
          return;
        }
        if (data && typeof data.token === "string") {
          setToken(data.token);
          if (typeof data.url === "string" && data.url) setUrl(data.url);
        } else if (data && typeof data.error === "string") {
          setError(data.error);
        } else {
          setError("Canlı ders başlatılamadı.");
        }
      } catch (e) {
        if (!cancelled) {
          setError(e instanceof Error ? e.message : "Bağlantı hatası.");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchToken();
    return () => {
      cancelled = true;
    };
  }, [roomCode, userName]);

  return { token, url, loading, error };
}
